"use client"

import { useTranslation } from "../hooks/useTranslation"
import { useGamingHub } from "../providers/GamingHubProvider"
import { useNative } from "../providers/NativeProvider"
import { LoginButton } from "./LoginButton"

/**
 * Persistent sign-in prompt for the native webview.
 *
 * Inside the GamingHub host app the hosted Sun header (and its login control) is
 * not rendered, so an anonymous user would otherwise have no way to sign in
 * short of triggering an action that calls `requireAuth()`. This bar surfaces
 * the host login flow directly.
 *
 * Self-gating: it only appears in native mode while anonymous, so it stays
 * hidden during the `loading` handshake, once authenticated, and in ordinary
 * web mode. It also disappears on the `NativeProvider` recovery path, since
 * `isNative` flips to `false` when no bridge shows up.
 */
export default function NativeAuthBar() {
  const { t } = useTranslation()
  const { isNative } = useNative()
  const { status } = useGamingHub()

  if (!isNative || status !== "anonymous") return null

  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-3 bg-[var(--dt-dark)] px-3 py-3 sm:px-4">
      <p className="min-w-0 font-sans text-[14px] text-white">
        {t("auth.nativeSignInPrompt")}
      </p>
      <LoginButton />
    </div>
  )
}
